/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */

/**
 * * `network` - Network
* `club` - Club
 */
export type OrganizationTypeEnum = typeof OrganizationTypeEnum[keyof typeof OrganizationTypeEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrganizationTypeEnum = {
  network: 'network',
  club: 'club',
} as const;
